/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { EN_US } from './en-us';
import { DictionaryService } from '../services/utilities/dictionary.service'; // Do not shorten

const dictionaryService = new DictionaryService();

const formattedUk: object = {};
for (const key in EN_US) {
    if (EN_US.hasOwnProperty(key)) {
        formattedUk[key] = dictionaryService.removeUSSpelling(EN_US[key]);
    }
}

export const EN_GB = formattedUk;
